// Color tokens are owned by config/theme.ts (single source of truth).
// Re-exported here so existing `constants` imports keep working.
export { TEAM_COLORS, POSITION_COLORS } from "./config/theme";

export const PLAYER_TABLE_COLUMNS = [
  { id: "name", label: "Name", numeric: false, minWidth: 120, maxWidth: 160 },
  { id: "team", label: "Team", numeric: false, width: 90 },
  { id: "position", label: "Position", numeric: false, width: 90 },
  { id: "exposure", label: "Exposure", numeric: true, width: 90 },
  { id: "count", label: "# Drafted", numeric: true, width: 75 },
  { id: "myAdp", label: "My ADP", numeric: true, width: 85 },
  { id: "udAdp", label: "UD ADP", numeric: true, width: 85 },
  { id: "clv", label: "CLV", numeric: true, width: 75 },
  { id: "clvPct", label: "CLV %", numeric: true, width: 75 },
];

export const CSV_HEADERS = [
  "Picked At", "Pick Number", "Appearance", "First Name", "Last Name", "Team", "Position",
  "Draft", "Draft Entry", "Draft Entry Fee", "Draft Size", "Draft Total Prizes",
  "Tournament Title", "Tournament", "Tournament Entry Fee", "Tournament Total Prizes",
  "Tournament Size", "Draft Pool Title", "Draft Pool", "Draft Pool Entry Fee",
  "Draft Pool Total Prizes", "Draft Pool Size", "Weekly Winner Title", "Weekly Winner",
  "Weekly Winner Entry Fee", "Weekly Winner Total Prizes", "Weekly Winner Size",
];

// Minimum headers required for the visualizer to function.
// The full CSV_HEADERS list is for Underdog's official export format;
// this subset also accepts CSVs generated by the rosterOS extension.
export const REQUIRED_CSV_HEADERS = [
  "First Name", "Last Name", "Position", "Pick Number", "Draft", "Tournament Title",
];

export const ALLOWED_EXPOSURE_VALUES = [
  10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50,
];

// ── Pagination ────────────────────────────────────────────────────
export const ROWS_PER_PAGE = 25;
export const COMBO_ROWS_PER_PAGE = 15;

// ── ADP ───────────────────────────────────────────────────────────
export const MAX_PICKS = 216;
export const DEFAULT_ADP_RANGE: [number, number] = [0, MAX_PICKS];

/**
 * ADP to assume for a player whose market ADP is missing/unparseable.
 * Underdog occasionally drops a still-draftable player's ADP (the feed reports
 * "-"), which would otherwise blank out every CLV that references him. Treating
 * a missing ADP as an undrafted-floor pick (just past MAX_PICKS) keeps CLV math
 * intact across all views instead of silently dropping the player.
 */
export const UNDRAFTED_ADP_FALLBACK = 240;
export const DEFAULT_EXPOSURE_THRESHOLD = 16;

/** Slider marks for the ADP range filter — every 12 picks (one round). */
export const ADP_MARKS = Array.from({ length: 19 }, (_, i) => ({
  value: i * 12,
  label: `${i * 12}`,
}));

// ── Shared Table Design Tokens ────────────────────────────────────
export const TABLE_MAX_HEIGHT = "75vh";
export const ROW_HOVER_SHADOW = "0 2px 8px rgba(0,0,0,0.08)";
export const ROW_HOVER_TRANSLATE = "translateX(2px)";
export const ZEBRA_ALPHA = 0.03;
export const HEADER_SHADOW = "0 2px 4px rgba(0,0,0,0.06)";
export const PAGE_SIZE = 50;
export const FILTER_BAR_ELEVATION = 1;
